import { styled, Grid, Box, Theme, LinearProgress } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const MainCont = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  [theme.breakpoints.down(1260)]: {
    flexDirection: 'column',
  },
}));

export const BorderedCont = styled(Box)<Theme, { padding?: number }>(({ theme, padding }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#0B0F14' : COLORS.WHITE,
  // border: 'solid 1px #2D343E',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  borderRadius: 8,
  marginBottom: 20,
  padding: padding,

  '& .MuiSvgIcon-root': {
    '&.documentIcon path': {
      fill: '#3e8bfe',
    },
  },
}));

export const Head = styled(Box)(({ theme }) => ({
  borderBottom: theme.palette.type === 'dark' ? 'solid 1px #2D343E' : `1px solid ${COLORS.LIGHT_BORDER}`,
  paddingBottom: 10,
  marginBottom: 20,
  display: 'flex',
}));

export const Info = styled(Box)(({ theme }) => ({
  marginBottom: 20,
}));

export const InfoItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 10,
}));

export const Foot = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 10,
}));

export const StorageBar = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  '& .MuiLinearProgress-bar ': {
    backgroundColor: COLORS.PRIMARY,
  },
}));

export const Content = styled(Box)<Theme, { maxHeight?: number | string }>(({ theme, maxHeight }) => ({
  padding: 10,
  display: 'flex',
  overflow: 'auto',
  flexWrap: 'wrap',
  maxHeight: maxHeight || 400,
}));

export const VideoContentContainer = styled('div')(({ theme, column }: { theme: Theme; column?: number }) => ({
  padding: 30,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 20,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: `repeat(${column !== undefined ? column : 5}, 1fr)`,
  },
}));

export const NoMediaCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: 100,
  fontSize: 18,
}));
